import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  return (
    <div className="about-container">
      <div className="about-content">
        <img src="/icons/logo-128x128.png" className="about-logo" alt="mfers arcade logo" />
        <h1>about mfers arcade</h1>

        <div className="about-section">
          <p>
            Welcome to mfers arcade - a collection of fun and engaging games
            built for the mfers community!
          </p>
        </div>

        <div className="about-section">
          <h2>Our Games</h2>
          <ul>
            <li><strong>Mfers Beheaded</strong> - Match-3 puzzle game with exciting challenges</li>
            <li><strong>Mfer Chess</strong> - Classic chess with a mfers twist</li>
            <li><strong>Alien 2048</strong> - Combine mfers to create the legendary Alien!</li>
            <li>And more coming soon!</li>
          </ul>
        </div>

        <div className="about-section">
          <h2>Get Started</h2>
          <p>
            Sign in with your X (Twitter) account to save your progress and
            compete on the leaderboards!
          </p>
        </div>

        <div className="about-section">
          <h2>Music Credits</h2>
          <p>
            Special thanks to <strong>TVARI</strong> for providing the amazing background music for mfers arcade:
          </p>
          <ul>
            <li>TVARI - Forever Love</li>
            <li>TVARI - Revive</li>
            <li>TVARI - Way</li>
            <li>TVARI - Lost Inside</li>
            <li>TVARI - Seoul Arcade</li>
            <li>TVARI - Tokyo Cafe</li>
          </ul>
          <p>
            Check out more of TVARI's music on their platforms!
          </p>
        </div>

        <div className="about-section">
          <h2>What's New</h2>
          <p>
            Check out our{' '}
            <Link to="/changelog" className="external-link">
              changelog
            </Link>
            {' '}to see the latest updates and improvements!
          </p>
        </div>

        <div className="about-section">
          <h2>Learn More</h2>
          <p>
            For more information about the project, check out our{' '}
            <a
              href="https://mirror.xyz/0xcC0Ba34FfE6107D4119FCa34dde7B09386bC8166/Msg--Ep4AWMQPJXwI04s9t6-Vj340MMh5VRdL6MlUDE"
              target="_blank"
              rel="noopener noreferrer"
              className="external-link"
            >
              official announcement
            </a>
          </p>
        </div>

        <Link to="/" className="back-link" onClick={() => window.scrollTo(0, 0)}>
          ← Back to Games
        </Link>
      </div>
    </div>
  );
}

export default About;
